export default {
    setMainPageContents(state, mainPageContent) {
        state.mainPageContent = mainPageContent;
    },
    setRightSideLinks(state, rightSideLinks) {
        state.rightSideLinks = rightSideLinks;
    },

}